export default __webpack_public_path__ + "static/media/vehiculo-puerta-barco.684d61b5.svg";